










































































































































































































































































































































































































































































































export default function (Component) {
  Component.options.__source = "src/module/master-data/views/editor/cmp-md-data-editor.vue"
}
